import "./styles/style.css";

import { Article } from "@/components/article";
import { Home } from "@/components/home";
import { Profile } from "@/components/profile";
import { UI } from "@/components/ui";
import { ScrollRestore } from "@/components/ui/scrollRestore";
import { Toast } from "@/components/ui/toast";
import { authService } from "@/services/AuthService";
import { pushService } from "@/services/PushService";
import { i18n } from "@/utils/i18n";

declare const __DEV__: boolean;
if (__DEV__) up.log.enable();

i18n.loaded();

authService.fromDOM();

// 初始化 Web Push 订阅管理（OneSignal）。
// 必须在 authService.fromDOM() 之后：init() 需要从 DOM 读取当前登录用户 ID。
// 异步执行、内部容错，不阻塞页面渲染。
pushService.init();

UI.compiler();
Article.compiler();
Home.compiler();
Profile.compiler();
ScrollRestore.compiler("[data-scroll-restore]");

up.on("server:auth:signout", (event: any) => {
  console.log(
    "[Main] server:auth:signout 登出成功 redirect:",
    event.redirect,
    "url:",
    event.redirectUrl,
  );
  up.emit("auth:signout", {
    parent: event,
  });
  if (event.redirect) {
    return up.visit(event.redirectUrl, { layer: "root" });
  }
  // 页面刷新
  up.reload();
});

up.on("up:layer:accepted", (event: up.LayerAcceptedEvent) => {
  if (event.value.type === "server:auth:signin") {
    console.log(
      "[Main] server:auth:signin 登入成功 redirect:",
      event.value.redirect,
      "url:",
      event.value.redirectUrl,
    );
    up.emit("auth:signin", { ...event.value });
    if (event.value.redirect) {
      return up.visit(event.value.redirectUrl, {
        history: "replace",
        layer: "root",
      });
    }
  }
});

// 后端兜底错误 → toast
// 后端 errorHandler 检测到 unpoly partial 请求时，会发 server:notify 事件，
// 不替换 DOM，仅在原页面上显示 toast。
up.on("server:notify", (event: any) => {
  const level =
    event.level === "error"
      ? "error"
      : event.level === "info"
        ? "info"
        : "warning";
  Toast.show({ message: event.message, type: level });
});

// 401 边界 → 弹出 signin overlay
// 后端 auth 中间件检测到 unpoly partial 未登录时，会发 server:auth:required 事件
up.on("server:auth:required", (event: any) => {
  if (event.message) Toast.show({ message: event.message, type: "warning" });
  up.layer.open({
    url: event.signinUrl,
    target: "#auth",
    size: "small",
    mode: "modal",
  });
});

// 2. 全局监听片段更新，确保图标始终可用（防止容器内容被意外重置）
up.on("up:fragment:inserted", (event) => {
  up.emit("fragment:inserted", {
    parent: event,
  });
});

// ⌘K / Ctrl+K：打开全局搜索面板
document.addEventListener("keydown", (e: KeyboardEvent) => {
  if ((e.metaKey || e.ctrlKey) && e.key === "k") {
    e.preventDefault();
    const trigger = document.querySelector<HTMLElement>(
      '[href$="/search"][up-layer]',
    );
    if (trigger) up.link.follow(trigger);
  }
});
